// extracted by mini-css-extract-plugin
export default {"findingCCD":"LoadingCcdReportPreview_findingCCD__MylwU","spinnerHolder":"LoadingCcdReportPreview_spinnerHolder__RAaQv","message":"LoadingCcdReportPreview_message__arEN+"};